var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#11192A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.546 2.438c.371.412.9.647 1.454.647.554 0 1.083-.235 1.454-.647L14.4 1.4c.556-.615 1.438-.814 2.203-.496.766.317 1.25 1.081 1.207 1.909l-.071 1.4c-.028.552.18 1.09.57 1.482.39.391.929.599 1.481.572l1.4-.071c.827-.04 1.59.443 1.907 1.208.316.765.117 1.647-.497 2.202l-1.042.94c-.411.372-.646.9-.646 1.455 0 .554.235 1.082.646 1.454l1.042.94c.615.556.814 1.438.496 2.203-.317.766-1.081 1.25-1.909 1.207l-1.4-.071c-.554-.028-1.093.179-1.485.57-.392.393-.6.932-.571 1.486l.071 1.4c.037.823-.446 1.581-1.207 1.897-.761.315-1.639.12-2.195-.487l-.941-1.041c-.371-.411-.9-.646-1.454-.646-.554 0-1.083.235-1.454.646L9.606 22.6c-.556.61-1.434.808-2.197.492-.763-.315-1.247-1.075-1.209-1.9l.072-1.4c.028-.554-.179-1.093-.57-1.485-.393-.392-.932-.6-1.486-.571l-1.4.071c-.827.043-1.592-.439-1.91-1.204-.318-.765-.12-1.647.494-2.203l1.041-.94c.411-.372.646-.9.646-1.455 0-.554-.235-1.082-.646-1.454L1.4 9.606C.788 9.051.59 8.171.906 7.407 1.222 6.644 1.984 6.161 2.81 6.2l1.4.071c.555.03 1.095-.179 1.488-.571.392-.393.6-.934.57-1.489L6.2 2.81c-.039-.825.444-1.586 1.208-1.902C8.17.592 9.05.788 9.606 1.4l.94 1.038z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.001,
    r: 4.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.f78b0d90bd1d40dcbcee87cff3951d3a.svg";
export { ForwardRef as ReactComponent };